import React from 'react'
import Navbar from '../navbar/Navbar'
import Footer from '../footer/Footer'
import PlacementsLeftTab from './PlacementsLeftTab';

const P2425 = () => {

    const placements2024_25 = [
        { sno: 1, logo: "Capgemini.png", salary: "4,50,000 - 7,50,000", total: 96 },
        { sno: 2, logo: "accenture.jpg", salary: "4,61,000 - 6,50,000", total: 128 },
        { sno: 3, logo: "hexaware.png", salary: "6,50,000", total: 1 },
        { sno: 4, logo: "tcs.png", salary: "3,60,000", total: 28 },
        { sno: 5, logo: "fedility.png", salary: "10,00,000", total: 2 },
        { sno: 6, logo: "techmahindra.png", salary: "3,50,000 - 5,50,000", total: 84 },
        { sno: 7, logo: "savantis.png", salary: "3,60,000", total: 51 },
        { sno: 8, logo: "cognizant.svg", salary: "4,25,000", total: 42 },
        { sno: 9, logo: "teachnook.png", salary: "6,00,000", total: 154 },
        { sno: 10, logo: "deloitte.png", salary: "7,60,000 - 4,25,000", total: 10 },
        { sno: 11, logo: "publicissapient.png", salary: "12,50,000", total: 2 },
        { sno: 12, logo: "infosys.png", salary: "3,60,000 - 6,25,000", total: 11 },
        { sno: 13, logo: "opentext.png", salary: "11,00,000 - 16,00,000", total: 11 }
    ];

    const baseLogoUrl = "https://admin.swec.ac.in/assetsswec/img/s-logos/";

    return (
        <div>
            <Navbar />

            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">

                        <div className="col-lg-4 pe-lg-4 order-2 order-lg-1">
                            <PlacementsLeftTab />
                        </div>

                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="how-to-apply">

                                <h2>Placements 2024–2025</h2>

                                <div className="table-responsive">
                                    <table className="table table-bordered table-hover align-baseline ">

                                        <thead className="table-dark text-center">
                                            <tr>
                                                <th>S.No</th>
                                                <th>Company</th>
                                                <th>Salary (LPA)</th>
                                                <th>Total Selections</th>
                                            </tr>
                                        </thead>

                                        <tbody className="text-center">
                                            {placements2024_25.map((c, i) => (
                                                <tr key={i}>
                                                    <td>{i + 1}</td>

                                                    <td className='py-1'>
                                                        <img
                                                            className='sixteen-nine'
                                                            src={`${baseLogoUrl}${c.logo}`}
                                                            alt={c.name}
                                                            style={{ height: "45px" }}
                                                        />
                                                        <div>{c.name}</div>
                                                    </td>

                                                    <td>{c.salary}</td>
                                                    <td>{c.total}</td>
                                                </tr>
                                            ))}
                                        </tbody>

                                    </table>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <Footer />
        </div>
    )
}

export default P2425;